import { RenderClient } from 'components/RenderClient';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { SWR_CACHE_CONTROL } from 'utils/swrCacheControl';
import BrowseChallenges from 'views/Challenges';

export const ChallengesList = () => {
  return (
    <>
      <Head>
        <title>Shuffle.com | Crypto Casino & VIP Betting Platform</title>
      </Head>
      <RenderClient>
        <BrowseChallenges />
      </RenderClient>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  res,
}: GetServerSidePropsContext) => {
  res.setHeader('Cache-Control', SWR_CACHE_CONTROL.STANDARD);

  return {
    props: {
      casinoLayout: true,
      activityBoard: true,
      ...(locale ? await serverSideTranslations(locale, ['common', 'errors']) : undefined),
    },
  };
};

export default ChallengesList;
